/* eslint-disable import/no-unresolved */
import { Panel } from 'appkit-react';
import ReactFlow from 'react-flow-renderer';
import React from 'react';

import noDataImg from 'assets/images/no-data.svg';
import FloatingEdge from './FloatingEdge';
import FileNode from './FileNode';
import FloatingConnectionLine from './FloatingConnectionLine';
import '../styles/mdrmcommonality.scss';

const nodeTypes = {
    default: FileNode,
};
const edgeTypes = {
    floating: FloatingEdge,
};
const MDRMCommonality = ({
    elements, onElementsRemove, onConnect, onLoad,
}) => (
    <Panel
        title="MDRM COMMONALITY"
        style={{ marginTop: '2rem' }}
    >
        {elements.length === 0 && (
            <div style={{ padding: '1rem 1.5rem', textAlign: 'center' }}>
                <img
                    src={noDataImg}
                    alt="No Data!!!"
                    style={{
                        width: '62.84px',
                        height: '62.82px',
                    }}
                />
            </div>
        )}
        {elements.length > 0 && (
            <div className="floatingedges">
                <ReactFlow
                    elements={elements}
                    onElementsRemove={onElementsRemove}
                    onConnect={onConnect}
                    onLoad={onLoad}
                    edgeTypes={edgeTypes}
                    nodeTypes={nodeTypes}
                    connectionLineComponent={FloatingConnectionLine}
                >
                    {/* <Background /> */}
                </ReactFlow>
            </div>
        )}
    </Panel>
);
export default MDRMCommonality;
